<script>
    import $ from '../plugins/vue-gridform/shared/helper'
    import CONSTANTS from '@src/constants'
    import _ from 'lodash'

    export default {
        name: 'CoachingPreview',
        props: {
            name: {
                type: String,
                default: () => 'coachingPreview'
            },
            uuid: {
                type: String,
                default: () => 'coachingPreviewId'
            },
            rows: {
                type: Array,
                default: () => []
            },
            disabled: {
                type: Boolean,
                default: true
            },
            validate: {
                type: Boolean,
                default: false
            },
            noActions: {
                type: Boolean,
                default: false
            },
            rating: {
                type: Object,
                default: () => null
            },
            devTools: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                gfc: null,
                gfTemplateConfig: {
                    flat: true,
                    fillHeight: false,
                    fluid: true,
                    padding: 'pa-0',
                    fieldstyle: 'outlined',
                    layoutClass: 'elevation-0 mb-4 mx-0',
                    fieldlistClass: 'mb-6',
                    disabled: this.disabled,
                    fieldlistFocusable: !this.disabled,
                    keys: !this.disabled,
                    validate: this.validate,
                    lazyValidation: false,
                    rating: this.rating,
                    actions: this.noActions ? null : ['cancel', 'save'],
                    uuid: true,
                    rows: []
                },
                callbacks: {
                    onSubmitAction: () => {this.$emit('submit')},
                    onCancelAction: () => {this.$emit('cancel')},
                    onFieldChange: fld => {this.$emit('change', $.payloadToStore(fld))},
                    onFieldListChange: () => {this.$emit('fieldlist')},
                    onFabClick: item => {this.$emit('fab', item)},
                    onFabAction: action => {this.$emit('fabaction', action)}
                }
            }
        },

        watch: {
            rows: {
                immediate: false,
                handler(rows) {
                    this.setRows(rows)
                }
            },
            disabled() {
                this.gfc.config({disabled: this.disabled})
                if (!this.disabled) this.disableFields()
            }
        },

        created() {
            if (this.$gridform[this.name]) {
                this.gfc = this.$gridform[this.name]
            }
        },
        mounted() {
            if (!this.gfc) {
                this.$gridform.ready(this.name, gf => {
                    this.gfc = gf
                    this.gfc.config({
                        disabled: this.disabled,
                        rating: this.rating,
                        actions: this.noActions ? null : ['cancel', 'save']
                    })
                    this.setRows(this.rows)
                })
            }
        },

        methods: {
            setRows(rows) {
                if (this.gfc) this.gfc.rows({rows, uuid: this.uuid})
            },
            loadRows(rows) {
                this.$toast.open({
                    type: CONSTANTS.TYPE_INFO,
                    text: 'Vorlage wird geladen...',
                    timeout: -1,
                    onMounted: (el) => {
                        console.log('toast mounted', el)
                        this.$nextTick(() => {
                            _.delay(() => {
                                this.gf.rows({rows})
                                this.$nextTick(() => {
                                    console.log('rows ready?')
                                    if (!this.disabled) this.disableFields()
                                })
                            }, 800)
                        })
                    }
                })
            },
            disableFields() {
                if (this.gfc) this.gfc.disable(['username', 'staff', 'employee', 'scriptureUser', 'scriptureStaff', 'scriptureEmployee', 'notes', 'notesPrivate'])
            }
        }
    }
</script>

<template>
    <VCard elevation="0" class="py-8">
        <VGridform :name="name" :config="gfTemplateConfig" :callbacks="callbacks" :dev-tools="devTools"/>
    </VCard>
</template>
